import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button, DropDownButton, DropDownButtonItemClickEvent } from '@progress/kendo-react-buttons';
import { useReduxDispatch, useReduxSelector } from '../../../../redux/hooks';
import { useNavigate, useParams } from 'react-router-dom';
import * as svg from '@progress/kendo-svg-icons';
import { UserApi } from '../../../../redux/api/UserApi';
import { TicketApi } from '../../../../redux/api/TicketApi';
import { setPagerTicketIds } from '../../../../slices/TicketDetailSlice';
import { ITicketProps } from '../../../../types/Ticket/ITicket';
import { PageType } from '../../../../types/Ticket/Pager/PageType';
import { useCurrentUserContext } from '../../../../context/UserContext';

const TicketPager: React.FC<ITicketProps> = ({ Is_Loading }) => {
    const navigate = useNavigate();
    const { ticketId } = useParams();
    //get FROM query string value
    const searchParams = new URLSearchParams(window.location.search.toLocaleLowerCase());
    const from = searchParams.get('from');
    const hpv = searchParams.get('hpv'); //Home paghe version, gets regenerated when the homepage changes
    const numericTicketId = Number(ticketId);
    const dispatch = useReduxDispatch();
    const ticketPager = useReduxSelector((state) => state.ticketDetails.pager);
    const currentIndex = ticketPager?.ticketIds?.findIndex(tId => tId === numericTicketId);
    const { profile } = useCurrentUserContext();
    const { data: myPages } = TicketApi.useGetTicketPagesQuery({ ticketId: numericTicketId, type: from as unknown as PageType }, { skip: profile?.Features.External_Interface });

    //put homepage ticket Ids in the pager state
    // React.useEffect(() => {
    //     if (myHomeTickets) {
    //         dispatch(setPagerTicketIds([...new Set(myHomeTickets.map(t => t.ID))].sort((a, b) => b - a)));
    //     }
    // }, [myHomeTickets, dispatch]);

    React.useEffect(() => {
        if (myPages) {
            dispatch(setPagerTicketIds([...new Set(myPages)].sort((a, b) => b - a)));
        }
    }, [myPages, dispatch]);

    const handlePrevious = () => {
        if (currentIndex > 0) {
            navigate(`/ticket/${ticketPager.ticketIds[currentIndex - 1]}/?from=${from}`);
        }
    };

    const handleNext = () => {
        if (currentIndex < ticketPager.ticketIds.length - 1) {
            navigate(`/ticket/${ticketPager.ticketIds[currentIndex + 1]}/?from=${from}`);
        }
    };

    //console.warn('TicketPager', Object.values(PageType).includes(from as unknown as PageType), Object.values(PageType), from)

    if (!ticketPager?.ticketIds || !from || !Object.values(PageType).map(PT => PT.toString().toLocaleLowerCase()).includes(from) || profile?.Features.External_Interface) return null;

    return (
        <div className='ticket-pager'>
            <Button className='off' fillMode='outline' size='small' title='Previous' svgIcon={svg.chevronLeftIcon} onClick={handlePrevious} disabled={currentIndex <= 0 || Is_Loading}>
            </Button>
            <small title={`${currentIndex + 1} of ${ticketPager.ticketIds.length} ${from} ${profile?.Phrases.CallPhrase}s`}>{currentIndex + 1} of {ticketPager.ticketIds.length}</small>
            <Button className='off' fillMode='outline' size='small' title='Next' svgIcon={svg.chevronRightIcon} onClick={handleNext} disabled={currentIndex >= ticketPager.ticketIds.length - 1 || Is_Loading}>
            </Button>
        </div>
    );
};

export default TicketPager;